"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
var Type;
(function (Type) {
    Type["SKILL"] = "SKILL";
    Type["ROLE"] = "ROLE";
    Type["TAG"] = "TAG";
    Type["LANGUAGE"] = "LANGUAGE";
    Type["WORK_POSITION"] = "WORK_POSITION";
    Type["EDUCATION_TITLE"] = "EDUCATION_TITLE";
    Type["PLAN"] = "PLAN";
})(Type || (Type = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["DISABLED"] = "DISABLED";
    Status["REJECTED"] = "REJECTED";
})(Status || (Status = {}));
exports.enums = {
    status: Status,
    type: Type,
};
//# sourceMappingURL=Autocomplete.js.map